import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./jsonPathPicker.html";
const data = [];
class ChildComponent extends LightningElement {
  constructor(...args) {
    super(...args);
    this.searching = false;
    this.options = data;
    this.formula = "";
    this.root = void 0;
    this.type = void 0;
    this.name = void 0;
    this.expr = void 0;
    this.rootPaths = [];
    // the accumulated list of expanded paths
    this.rootObjs = {};
    // pointers to objects that have been expanded
    this.firstTime = true;
  }
  get label() {
    return this.name;
  }
  get rows() {
    return this.expr ? this.expr.split("\n").length + 1 : 2; // min 2 rows
  }
  get inputClass() {
    return `search-input input-${this.type}`;
  }
  connectedCallback() {
    // Ensure the passed-in root is an object
    let rootObj = typeof this.root == "string" ? eval(this.root) : this.root;
    this.rootPaths = this.subPaths(rootObj, ""); // initial path prefix is blank
    // this.addPaths(this.rootPaths);

    this.rootPaths.forEach(path => {
      this.addPaths(this.subPaths(rootObj[path], path)); // expand first level
    });
  }
  renderedCallback() {
    if (!this.firstTime) return;
    const searchInput = this.template.querySelector('.search-input');
    //SHR240520: adjust the textarea height to show multi-line expressions
    const textArea = searchInput.shadowRoot.querySelector('.slds-textarea');
    if (textArea) {
      textArea.rows = this.rows;
    }

    // HANDLE ARROWS TO MOVE BETWEEN OPTIONS
    const keyEvent = e => {
      const validKeys = ['ArrowUp', 'ArrowDown', 'ArrowRight', 'Tab', 'Enter'];
      if (!this.searching || !validKeys.includes(e.key)) {
        return;
      }
      e.preventDefault();
      let allOptions = this.template.querySelectorAll('.list-option');
      let curOption = this.template.querySelector('.option-hover');
      if (curOption && (e.key == 'ArrowRight' || e.key == 'Tab' || e.key == 'Enter')) {
        this.expr = curOption.textContent;
        this.searching = false;
        return;
      }
      let curIndex = curOption ? [...allOptions].findIndex(option => option == curOption) : -1;
      if (curIndex >= 0) {
        allOptions[curIndex].classList.remove('option-hover');
      }
      let optDelta = e.key == 'ArrowUp' ? curIndex < 0 ? 0 : -1 : e.key == 'ArrowDown' ? +1 : 0;
      let optIndex = e.key.startsWith('Arrow') ? (allOptions.length + curIndex + optDelta) % allOptions.length : curIndex;
      if (optIndex >= 0) {
        allOptions[optIndex].classList.add('option-hover');
        allOptions[optIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
      // console.debug(`${e.key}: ${curIndex} + ${optDelta} = ${optIndex}`);
    };
    searchInput.addEventListener('keydown', keyEvent);
    this.firstTime = false;
  }
  addPaths(paths) {
    let newPaths = Array.isArray(paths) ? paths.filter(path => !data.includes(path)) : [];
    if (newPaths.length) {
      console.debug(`Found ${newPaths.length} new paths...`);
      data.push(...newPaths);
      console.info(data);
    }
  }
  subPaths(parent, prefix) {
    let paths = typeof parent == "object" ? Object.getOwnPropertyNames(parent) : [];
    if (Array.isArray(parent) && parent.length) {
      paths = Object.getOwnPropertyNames(parent[0]); // shortcut -- should ckeck all object properties?
    }
    paths.forEach(path => {
      let child = parent[path];
      if (typeof child == "object") {
        let objPath = prefix ? `${prefix}.${path}` : path;
        this.rootObjs[`${objPath}.`] = child;
      }
    });
    if (prefix && paths) {
      paths = paths.map(path => `${prefix}.${path}`);
    }
    return paths;
  }
  handleSelectionAC(e) {
    console.debug(e.type, `${range.selectionStart} - ${range.selectionEnd}`);
  }
  handleChangeAC(e) {
    const value = e.target.value;
    this.expr = value; // for now - need to swap selected value into formula

    // CHECK IF THE USER IS SEARCHING
    // let roots = this.rootPaths.filter(root => value.includes(`${root}.`));
    if (data && value) {
      // this.searching = true;
      // this.searching = roots && roots.length; // wait until "root." is typed
      this.searching = this.options.length > 0; // typing a new value ends the search
      // console.debug("Found roots:", roots);
    } else {
      this.searching = false;
      this.options = data;
      return;
    }

    // FILTER VALUES
    // this.options = data.filter(path => path.startsWith(value)); // match starts at the root
    this.options = data.filter(path => path.includes(value));
    // console.debug("Option paths:", this.options);

    if (this.options.length == 0 && value.endsWith(".")) {
      let prefix = value.slice(0, -1);
      this.options = this.subPaths(this.rootObjs[value], prefix); // expand next level
      this.addPaths(this.options);
    }
  }
  handleBlurAC() {
    // GIVE TIME TO THE USER TO SELECT THE OPTION
    setTimeout(() => {
      this.searching = false;
    }, 100);
  }
  handleClickOption(e) {
    // POPULATE AND RESTORE INPUT VARIABLES
    const value = e.currentTarget.textContent;
    const input = this.template.querySelector('.search-input');
    let oldValue = input.value;
    input.focus;
    input.setRangeText(value, 0, oldValue.length || 0, "select");
    // this.expr = value; // for now - but needs to swap selected value into formula
    this.searching = false;
  }
  disconnectedCallback() {
    this.template.querySelector('.search-input').removeEventListener();
  }
}
_registerDecorators(ChildComponent, {
  publicProps: {
    root: {
      config: 0
    },
    type: {
      config: 0
    },
    name: {
      config: 0
    },
    expr: {
      config: 0
    },
    label: {
      config: 1
    },
    rows: {
      config: 1
    },
    inputClass: {
      config: 1
    }
  },
  track: {
    searching: 1,
    options: 1,
    formula: 1
  },
  fields: ["rootPaths", "rootObjs", "firstTime"]
});
export default _registerComponent(ChildComponent, {
  tmpl: _tmpl
});